export default {
    md: {
        mobile: '(max-width: 767px)',
        desktop: '(min-width: 768px)',
    },
    '2xl': {
        mobile: '(max-width: 1535px)',
        desktop: '(min-width: 1536px)',
    },
};
